import { styled, css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export const Display = styled.div<{ $hasSelection?: boolean }>`
  ${({ theme: { colors, fontSizes }, $hasSelection }) => css`
    align-items: center;
    background: ${colors.brandDarkAlpha5};
    border-radius: 0.25rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
    outline: 1px solid transparent;
    padding: ${$hasSelection ? '0.438rem 0.5rem 0.438rem 0.5rem' : '0.438rem 0.5rem 0.438rem 1rem'};
    box-sizing: border-box;
    font-size: ${fontSizes.s16};

    input {
      background: transparent;
      border: 0;
      color: ${colors.brandDark};
      flex: 1 1 1rem;
      font-size: inherit;
      margin: 0;
      min-inline-size: 0;
      min-width: 1rem;
      outline: unset;
      padding: 0;
      width: auto;

      &::placeholder {
        color: ${colors.brandDarkTint50};
      }
    }

    &:focus-within {
      outline-color: ${colors.brandPrimary};
    }
  `}
`;

export const List = styled.div<{ $minWidth?: number }>`
  ${({ theme: { colors }, $minWidth }) => css`
    background: ${colors.brandLight};
    border-radius: 0.25rem;
    box-shadow:
      0 0 0 1px ${colors.brandDarkTint80},
      0 0.75rem 0.5rem -0.25rem rgba(32, 30, 36, 0.15),
      0 0.25rem 0.25rem -0.125rem rgba(32, 30, 36, 0.2);
    margin: 0;
    min-width: ${$minWidth}px;
    width: ${$minWidth ? `${$minWidth}px` : 'max-content'};
    ul {
      display: flex;
      flex-direction: column;
      margin: 0;
      padding: 0.5rem;
      max-height: 11.375rem;
      overflow-y: auto;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        border-radius: 8px;
        height: 8px;
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: white;
        border-radius: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background-clip: padding-box;
        background-color: ${colors.brandDarkTint80};
        border-radius: 8px;
        height: 8px;
        -webkit-border-radius: 8px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: ${colors.brandDarkTint70};
      }
    }
  `}
`;

export const ListItem = styled.li<{ $disabled?: boolean }>`
  ${({ theme: { borderRadius, colors, fontSizes }, $disabled }) => css`
    align-items: center;
    border-radius: ${borderRadius.sm};
    box-sizing: border-box;
    display: flex;
    font-size: ${fontSizes.s14};
    line-height: 1em;
    min-height: 2.5rem;
    padding: 0.5rem 1rem;
    user-select: none;

    ${
      !$disabled &&
      css`
        cursor: pointer;

        &:hover {
          background: ${colors.brandPrimaryAlpha5};
          color: ${colors.brandPrimary};
        }

        &:focus-within,
        &:focus {
          color: ${colors.brandPrimary};
          outline-color: ${colors.brandPrimary};
          outline-offset: 2px;
          outline-width: 1px;
        }
      `
    }
  `}
`;

export const SelectedOption = styled.div`
  ${({ theme: { borderRadius, colors, fontSizes } }) => css`
    align-items: center;
    background: ${colors.brandDarkTint90};
    border-radius: ${borderRadius.sm};
    display: flex;
    font-size: ${fontSizes.s12};
    gap: 0.5rem;
    padding: 0.25rem 0.375rem 0.25rem 0.438rem;
    user-select: none;
    z-index: 1;

    span {
      color: ${colors.brandDark};
      display: -webkit-box;
      line-height: 1.2;
      overflow: hidden;
      max-width: 15rem;
      font-size: inherit;
      padding: 0.063rem 0 0.063rem 0;
      text-align: left;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    button {
      flex-shrink: 0;
      aspect-ratio: 1 / 1;
      height: 1rem;
      min-width: unset;
      width: 1rem;

      .icon {
        height: 1rem;
        padding: 0;
        width: 1rem;

        path {
          stroke: ${colors.brandDark};
          stroke-width: 1.5;
        }
      }
    }

    &:focus {
      outline-color: ${colors.brandDark};
      outline-offset: 2px;
      outline-width: 1px;
    }
  `}
`;

export const Spacer = styled.span`
  ${({ theme: { colors } }) => css`
    display: block;
    background: ${colors.brandDarkAlpha10};
    min-height: 1px;
    margin: 0.5rem 0;
    margin-left: -0.5rem;
    width: calc(100% + 1rem);
  `}
`;
